import React from 'react';
import Header from './Header';
import Footer from './Footer';

const TermsPage = () => {
    return (
        <div className="min-h-screen bg-gray-50 flex flex-col">
            <Header />
            <main className="grow max-w-4xl mx-auto px-4 py-12">
                <div className="bg-white rounded-2xl shadow-sm p-8 md:p-12">
                    <h1 className="text-3xl font-bold text-gray-900 mb-8">Conditions d'utilisation</h1>

                    <div className="prose prose-purple max-w-none text-gray-600">
                        <section className="mb-8">
                            <h2 className="text-xl font-semibold text-gray-900 mb-4">Acceptation des conditions</h2>
                            <p>
                                En accédant à Linkoo et en l'utilisant, vous acceptez d'être lié par les présentes conditions d'utilisation. Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser nos services.
                            </p>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-xl font-semibold text-gray-900 mb-4">Description du service</h2>
                            <p>
                                Linkoo est une plateforme de gestion de cartes de visite numériques et de réseautage professionnel. Nous nous réservons le droit de modifier ou d'interrompre le service à tout moment, avec ou sans préavis.
                            </p>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-xl font-semibold text-gray-900 mb-4">Compte utilisateur</h2>
                            <p>
                                Vous êtes responsable de la confidentialité de vos identifiants de connexion et de toutes les activités qui se produisent sous votre compte. Vous devez nous informer immédiatement de toute utilisation non autorisée de votre compte.
                            </p>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-xl font-semibold text-gray-900 mb-4">Utilisation acceptable</h2>
                            <p>
                                Vous vous engagez à ne pas utiliser le service pour des activités illégales ou interdites. Vous ne devez pas perturber ou tenter de perturber le fonctionnement du service.
                            </p>
                        </section>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default TermsPage;
